export default {
  root: {
    padding: 0,
  },
};
